import React, {useCallback} from "react";
import Snackbar from "@mui/material/Snackbar";
import {useSelector, useDispatch} from "react-redux";
import * as notificationActions from "../../actions/notificationActions";
import Button from "@mui/material/Button";

const ArgoAppSnackbarHook = () => {
    const dispatch = useDispatch();
    const notification = useSelector(state => state.notification);

    const closeHandler = useCallback(() => {
        dispatch(notificationActions.notificationClosed());
    }, [dispatch]);

    return (
        <div>
            <Snackbar
                style={{
                    zIndex: "20",
                    width: "100%",
                    justifyContent: "center",
                    alignContent: "center",
                    maxWidth: "100%",
                }}
                bodystyle={{
                    maxWidth: "80%",
                }}
                action={<Button onClick={closeHandler} sx={{color: 'white'}}>Close</Button>}
                open={notification.open}
                message={notification.message}
                autoHideDuration={30000}
                onClose={(event, reason) => {
                    if (reason !== "clickaway") {
                        closeHandler();
                    }
                }}
            />
        </div>
    );
};

ArgoAppSnackbarHook.propTypes = {};

export default ArgoAppSnackbarHook;
